import React, { FC, useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "../../Components/ui/card";
import { Button } from "../../Components/ui/button";
import { Progress } from "../../Components/ui/progress";
import { Toaster } from "../../Components/ui/toaster";
import { toast, useToast } from "../../Components/ui/use-toast";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../Components/ui/table";
import { Badge } from "../../Components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from '../../Components/ui/avatar';
import { CaretSortIcon } from "@radix-ui/react-icons";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../../Components/ui/dropdown-menu';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/src/State/store";
import { Elements, useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Navigate, useNavigate } from "react-router-dom";
import { setAvailableMessages, setSentCount, setTotalAvailableCount } from "../../State/slices/AdvertiserAccountSlice";
import { convertUTCToLocal } from "../../../src/utils/convertUTCToLocal";
import { useLocation } from 'react-router-dom';


interface WorkspaceAPIResponseItem {
  workspace_info_id: number;
  workspace_name: string;
  is_wallet_status: boolean;
  created_date: string;
  workspace_image: string;
}
interface TransactionDetails {
  payment_id: number;
  payment_time: string | null;
  currency: string | null;
  amount: number;
  credited_msg_count: number;
  plan_id: number | null;
  plan_name: string | null;
  plan_desc: string;
  receipt_url: string | null;
}


interface BillingPlan {
  billing_name: string;
  amount: number;
  features: string;
  symbol: string;
  currency: string;
}




interface Transactions {
  paymentId: string;
  amount: string;
  paymentDate: string;
  symbol: string;
  receipturl: string;
  name: string;
  messages: string;
  fundtype: string;
}
interface Debitdetials {
  amount: string;
  messagecount: string;
  paymentdate: string;
  symbol: string;
  lastdebited_date: string;

}




const Billing: FC = () => {

  const toast = useToast();

  const [showAddFunds, setShowAddFunds] = useState(false);
  const [billingCountryCurrency, setBillingCountryCurrency] = useState("");
  const [billingCountryCurrencySymbol, setBillingCountryCurrencySymbol] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [paymentLink, setPaymentLink] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [debitList, setdebitList] = useState<Debitdetials[]>([]);
  const [sentMessages, setSentMessages] = useState<number>(0);
  const [totalPurchasedMessages, setTotalPurchasedMessages] = useState<number>(0);
  const [transactionSortOrder, setTransactionSortOrder] = useState("asc");
  const mailId = useSelector((state: RootState) => state.authentication.userEmail);
  const [isSorted, setIsSorted] = useState(false);
  const [walletAmount, setWalletAmount] = useState<number>(0);
  const [open, setOpen] = useState(false);
  const [availableMessageCount, setAvailableMessageCount] = useState<number>(0);



  //Present

  const [workspaceslist, setWorkspaceslist] = useState<WorkspaceAPIResponseItem[]>([]);
  const [walletStatusList, setWalletStatusList] = useState<boolean>();
  const [transactionList, setTransactionList] = useState<TransactionDetails[]>([]);
  const [billingDetails, setBillingDetails] = useState<BillingPlan[]>([]);


  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [mountStatus, setMountStatus] = useState(false);
  const handleOpen = () => {
    setOpen(true)
    setMountStatus(true);
  };
  const handleClose = () => {
    setOpen(false);
    setMountStatus(false);
    navigate('/settings/notification', { state: { route: "notification" } });
  };

  const [isLoading, setIsLoading] = useState(false);
  const workspaceId = useSelector((state: RootState) => state.authentication.workspace_id);
  const accountId = useSelector((state: RootState) => state.authentication.account_id);
  const apiUrlAdvAcc = useSelector((state: RootState) => state.authentication.apiURL);
  const workspaceTimezone = useSelector((state: RootState) => state.authentication.workspaceTimezone);
  const isImpersonated = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonationState
  );
  const impersonatorAID = useSelector(
    (state: RootState) => state.admin.Impersonator?.ImpersonatorAID
  );



  // Then in your component:
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  // In your Billing component
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('payment') === 'success') {
      // Handle success without reload
      // Show success message, update UI, etc.
      // Remove the parameter from URL without reload
      window.history.replaceState({}, '', '/settings/Billing');
      GetUserTransactions();
      GetAvailableMessageCount();
    }
  }, []);


  useEffect(() => {
    console.log('Current URL:', location.search);
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('payment') === 'success') {
      console.log('Payment success detected!');
    }
  }, [location]);

  // useEffect(() => {
  //   if (apiUrlAdvAcc) {
  //     APICALLS();
  //   }
  // }, [apiUrlAdvAcc]);



  // const APICALLS = async () => {
  //   try {
  //     setIsLoading(true);
  //     await Promise.all([

  //     ]);
  //   } catch {
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    GetUserTransactions();
    GetAvailableMessageCount();
    GetWorkspaces();
    fetchBillingPlans();
    const timeoutId = setTimeout(() => {
      GetUserTransactions();
      GetAvailableMessageCount();
      console.log("TImeout")
    }, 5000);

    return () => clearTimeout(timeoutId); // cleanup if apiUrlAdvAcc changes or component unmounts
  }, [apiUrlAdvAcc]);


  const [productDetails, setProductDetails] = useState(null);



  const [priceId, setPriceId] = useState<string | null>(null);
  const [productName, setProductName] = useState<string | null>();
  // const [clientSecret, setclientSecret] = useState<string | null>();
  const [quantity, setQuantity] = useState<number>(1);
  const [workspaceid, setWorkspaceid] = useState<number>();




  const handleCreatePaymentLink = async (PriceId: any, ProductName: any, Quantity: number) => {
    try {
      const data = {
        PriceId: PriceId,
        Quantity: Quantity,
        ProductName: ProductName
      };

      // Send the request to CreatePaymentLink API
      const response = await axios.post(`${apiUrlAdvAcc}/CreatePaymentLink`, data);

      if (response.data) {
        const paymentLink = response.data; // Assuming `url` is returned in the response
        const paymentId = response.data.paymentId; // Assuming paymentId is returned as well

        // Open the payment link
        //   window.location.href = paymentLink;


      }
    } catch (error) {
    }
  };




  const parseTransactionCustomDate = (dateString: string) => {

    const [datePart, timePart] = dateString.split("∙");
    const [day, month, year] = datePart.trim().split("/");
    return new Date(`${year}-${month}-${day}T${timePart.trim()}`);
  };

  const parseCustomDate = (dateString: string) => {
    const [day, month, year] = dateString.trim().split("/");
    return new Date(`${year}-${month}-${day}`);
  };


  const formatDescription = (features: string, symbol: string) => {
    // Split the features by commas and process each feature
    let formattedDescription = "Includes: ";
    const formattedFeatures = features.split(",").map((feature) => {
      // If the feature contains "per message", handle it
      if (feature.includes("per message")) {
        const parts = feature.trim().split(" "); // Split into parts (e.g., ["100000", "messages", "per", "message", "1.20"])

        // Ensure the feature contains a price at the end (e.g., "1.20")
        if (parts.length >= 2 && !isNaN(parseFloat(parts[2]))) {
          // Format the feature as "100000 messages, per message ₹ 1.20"
          return ` ${parts[0]} ${parts[1]} ${symbol} ${parts[2]}`;
        } else {
          // If the format is invalid, return the feature unchanged
          return feature;
        }
      } else {
        // If the feature does not include "per message", return it unchanged
        return feature;
      }
    });

    // Join the features back into a single string and return it
    formattedDescription += formattedFeatures.join(", ");

    // Return the formatted description
    return formattedDescription;
  };








  // const sortWorkspaces = (tableHeader: string) => {
  //   let sortedData = [...workspaceslist];

  //   switch (tableHeader) {
  //     case "Byworkspace":
  //       sortedData.sort((a, b) =>
  //         sortOrder === "asc"
  //           ? a.workspace.localeCompare(b.workspace)
  //           : b.workspace.localeCompare(a.workspace)
  //       );
  //       break;
  //     case "ByPaired":
  //       sortedData.sort((a, b) =>
  //         sortOrder === "asc"
  //           ? new Date(a.paireddate).getTime() - new Date(b.paireddate).getTime()
  //           : new Date(b.paireddate).getTime() - new Date(a.paireddate).getTime()
  //       );
  //       break;

  //     default:
  //       return;
  //   }

  //   setWorkspaceslist(sortedData);
  //   setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  // };

  const formatAmount = (amount: number): string => { return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }

  //New Ones

  // const sortTransactions = (field: string) => {
  //   let sortedList = [...transactionList];

  //   switch (field) {
  //     case "ByValues":
  //       sortedList.sort((a, b) =>
  //         transactionSortOrder === "asc"
  //           ? a.amount.localeCompare(b.amount)
  //           : b.amount.localeCompare(a.amount)
  //       );
  //       break;

  //     case "ByMessages":
  //       sortedList.sort((a, b) =>
  //         transactionSortOrder === "asc"
  //           ? a.messages.localeCompare(b.messages)
  //           : b.messages.localeCompare(a.messages)
  //       );
  //       break;

  //     case "ByDescription":
  //       sortedList.sort((a, b) =>
  //         transactionSortOrder === "asc"
  //           ? a.name.localeCompare(b.name)
  //           : b.name.localeCompare(a.name)
  //       );
  //       break;

  //     case "ByDate":
  //       sortedList.sort((a, b) =>
  //         transactionSortOrder === "asc"
  //           ? parseTransactionCustomDate(a.paymentDate).getTime() - parseTransactionCustomDate(b.paymentDate).getTime()
  //           : parseTransactionCustomDate(b.paymentDate).getTime() - parseTransactionCustomDate(a.paymentDate).getTime()
  //       );
  //       break;

  //     default:
  //   }

  //   setTransactionList(sortedList);
  //   setTransactionSortOrder(transactionSortOrder === "asc" ? "desc" : "asc");
  // };







  //New APIs



  const GetAvailableMessageCount = async () => {
    try {
      const response = await axios.get(
        `${apiUrlAdvAcc}/GetAvailableMessageCount?accountId=${accountId}`
      );

      if (
        response.data?.status === "Success" &&
        typeof response.data.available_message_count === "number"
      ) {
        console.log("Available message count:", response.data.available_message_count);
        setAvailableMessageCount(response.data.available_message_count); // 👈 set your state
        dispatch(setAvailableMessages(response.data.available_message_count));
      } else {
        console.warn("Invalid response or message count missing");
        return null;
      }
    } catch (error) {
      console.error("Error fetching available message count:", error);
      return null;
    }
  };


  const GetWorkspaces = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetBillingWorkspaceDetailsByAccountIDFromWorkspaceInfoTable?accountId=${accountId}`);

      if (response.data?.status === "Success" && Array.isArray(response.data.data)) {
        setWorkspaceslist(response.data.data);
      } else {
        console.warn("No data returned or invalid response format");
        setWorkspaceslist([]);

      }
    } catch (error) {
      console.error("Error fetching workspace details:", error);
      setWorkspaceslist([]);

    }
  };


  // const updateWalletStatus = async (

  //   walletStatus: boolean,
  //   workspaceId: number
  // ): Promise<boolean> => {
  //   try {
  //     const response = await axios.put(
  //       `${apiUrlAdvAcc}/UpdateWalletStatusByWorkspaceID`,
  //       {
  //         WorkspaceInfoId: workspaceId,
  //         WalletStatus: walletStatus,
  //       }
  //     );

  //     if (response.data?.status === "Success") {
  //       console.log("Wallet status updated successfully");
  //       GetWorkspaces();
  //       toast.toast({
  //         title: "Success",
  //         description: "Wallet status updated successfully",
  //       })
  //       return true;
  //     } else {
  //       console.warn("Failed to update wallet status:", response.data?.status_description);
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("Error updating wallet status:", error);
  //     return false;
  //   }
  // };

  const updateWalletStatus = async (
    walletStatus: boolean,
    workspaceId: number,
    accountId: number
  ): Promise<boolean> => {
    try {
      const response = await axios.put(
        `${apiUrlAdvAcc}/UpdateWalletStatusByWorkspaceID`,
        {
          AccountId: accountId,
          WorkspaceInfoId: workspaceId,
          WalletStatus: walletStatus,
          ImpersonatorUserAccountId: isImpersonated ? impersonatorAID : null
        }
      );

      if (response.data?.status === "Success") {
        console.log("Wallet status updated successfully");
        GetWorkspaces();
        toast.toast({
          title: "Success",
          description: response.data.status_description,
        });
        return true;
      } else {
        console.warn("Failed to update wallet status:", response.data?.status_description);
        toast.toast({
          title: "Warning",
          description: response.data?.status_description || "Failed to update wallet status",
          variant: "destructive",
        });
        return false;
      }
    } catch (error) {
      console.error("Error updating wallet status:", error);
      toast.toast({
        title: "Error",
        description: "An error occurred while updating wallet status",
        variant: "destructive",
      });
      return false;
    }
  };



  const GetUserTransactions = async () => {
    try {
      const response = await axios.get(`${apiUrlAdvAcc}/GetUserTransactions?accountId=${accountId}`);

      if (response.data?.status === "Success" && Array.isArray(response.data.data)) {
        setTransactionList(response.data.data as TransactionDetails[]);
      } else {
        console.warn("No transaction data found or invalid response format");
        setTransactionList([]);
      }
    } catch (error) {
      console.error("Error fetching user transactions:", error);
      setTransactionList([]);
    }
  };


  const downloadInvoice = async (id: string) => {
    toast.toast({
      title: "Downloading..",
      description: "Invoice downloading",
      duration: 3000,
    });
    try {
      // Send GET request to your backend endpoint
      const response = await axios.get(
        `${apiUrlAdvAcc}/DownloadInvoicePdf?invoiceId=${id}`,
        {
          responseType: "blob", // Ensure the response is treated as a file
        }
      );



      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);

      // Create a link element to initiate download
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "invoice.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.toast({
        title: "Success",
        description: "Invoice downloaded successfully!",
        duration: 3000,
      });
    } catch (error) {
      toast.toast({
        title: "Error",
        description: "Failed to download receipt. Please try again.",
        duration: 3000,
      });
    }
  };


  const fetchBillingPlans = async () => {
    try {


      const response = await axios.get(`${apiUrlAdvAcc}/GetPlansByAccountID`, {
        params: { accountId: accountId },
      });

      if (response.data?.status === 'Success') {
        const plans = response.data.billing_plans as BillingPlan[];
        setBillingDetails(plans);
      } else {
        console.warn(response.data?.status_Description || 'Failed to fetch billing plans');
        setBillingDetails([]); // Clear on failure
      }
    } catch (error) {
      console.error('Error fetching billing plans:', error);
      setBillingDetails([]); // Clear on error
    }
  };



  const handlePurchase = async (plan: BillingPlan) => {
    try {

      setIsLoading(true);
      handleOpen();
      const formattedDescription = formatDescription(plan.features, plan.symbol);
      const data = {
        Amount: plan.amount,
        Currency: plan.currency,
        ProductName: plan.billing_name,
        Description: formattedDescription,
      }
      const response = await axios.post(`${apiUrlAdvAcc}/CreateProductWithPrice`, data, {
        headers: {
          'Content-Type': 'application/json', // Include the token here
        },

      });
      if (response.data) {
        const { productId, priceId, productName } = response.data;

        const productDetails = {
          priceId: priceId,
          quantity: 1,
        };
        setPriceId(priceId);
        setProductName(productName);
        setQuantity(1);
        setWorkspaceid(workspaceId);
        setIsLoading(false);


        navigate("/settings/checkout", {
          state: {
            route: "Billing",
            priceId: priceId,
            quantity: quantity,
            productName: productName
          }
        })



        // await handleCreatePaymentLink(priceId, productName, quantity)
      }
      // }
    } catch (error) {
    }
  };









  // useEffect(() => {

  // }, [])



  return (
    <div className="flex-col gap-6 max-h-screen overflow-y-auto pl-2 pr-2">
      {/* Loading Overlay */}
      {isLoading && (
        <div className="absolute inset-0 bg-gray-500/50 flex items-center justify-center z-50">
          <CircularProgress className="text-primary" />
        </div>
      )}
      <Toaster />


      <Card className="mt-2 mb-6">
        <CardHeader className="p-4">
          <div className="flex justify-between items-center w-full">
            {/* Left Section - Message Label and Count */}
            <div className="flex items-center space-x-4">
              <span className="text-[1.125rem] text-gray-800 font-medium">
                Total Available Messages :
              </span>
              <span className="text-[1.125rem] font-semibold text-[#3A85F7]">
                {availableMessageCount}
              </span>
            </div>

            {/* Right Section - Button */}
            <Button
              className="bg-[#3A85F7]  text-white mb-4  rounded-md max-w-[150px] h-12"
              onClick={() => {
                if (showAddFunds) {
                  setShowAddFunds(false);
                  return;
                }

                if (billingDetails.length === 0) {
                  toast.toast({
                    title: "Alert",
                    description: "No available plans for your billing country",
                    duration: 1000,
                  });
                  return;
                }

                setShowAddFunds(true);
              }}
            >
              {showAddFunds ? 'Back' : '+ Add Funds'}
            </Button>
          </div>
        </CardHeader>
      </Card>



      {/* {priceId && <EmbeddedCheckout1 priceId={priceId} quantity={quantity} />} */}
      {/* {priceId && <BillingDialog priceId={priceId} quantity={quantity} productName={productName ?? ''} open={open} handleClose={handleClose} mountStatus={mountStatus}/>} */}

      {showAddFunds && (
        <div className="flex flex-row flex-wrap w-full gap-4 pb-20">
          {billingDetails.map((plan, index) => (
            <div key={index} className={(((index + 1) % 2 !== 0) && ((billingDetails.length) - 1 === index)) ? "basis-1/2" : "grow basis-1/3"}>
              <Card key={index} className="w-auto p-6 border border-grey text-left">
                <Typography
                  component="h3" className="flex flex-col items-center justify-center text-sm font-semibold mb-1 pb-1"
                  style={{ fontWeight: 600, fontSize: "14px" }}
                >
                  <span className="mb-1">{plan.billing_name}</span>
                  <div className="flex items-center space-x-1 ml-2">
                    <span>{plan.currency}</span>
                    <span>{formatAmount(plan.amount)}</span>
                  </div>
                </Typography>
                <Typography
                  component="p" className="flex flex-col text-sm text-gray-500 mb-4" style={{ fontSize: "14px" }}
                >
                  <span style={{ fontWeight: 600 }}>Includes:</span>
                  {plan.features.split(",").map((feature, i) => {
                    const isPerMessage = feature.includes("per message");
                    if (isPerMessage) {
                      const parts = feature.split(" ");
                      return (
                        <div key={i} className="flex items-center space-x-1 mt-1">
                          <span>✓</span> <span>{Number(parts[0]).toLocaleString()} {parts[1]}</span>
                          <span>{plan.symbol}</span> <span>{parts[2]}</span>
                        </div>);
                    }
                    else {
                      return (
                        <div key={i} className="flex flex-col space-y-1 mt-1">
                          <div className="flex items-center space-x-1">
                            <span>✓</span> <span>{feature.replace(/\d+/g, (match) => Number(match).toLocaleString())} messages </span>
                          </div>
                          <div className="flex items-center space-x-1">
                            {/* <span>✓</span> per message {plan.symbol} <span>{plan.permessage}</span> */}
                          </div>
                        </div>
                      );
                    }
                  })}
                </Typography>

                <Button className="py-1 px-3 text-sm w-full mt-4" style={{ fontWeight: 500, fontSize: "14px" }} onClick={() => handlePurchase(plan)} >
                  Purchase
                </Button>

              </Card>
            </div>
          ))}
        </div>
      )}

      {!showAddFunds && (
        <>
          {/* { workspace }  */}
          <Card className=''>
            <CardHeader>
              <div>
                <h2 className="text-lg font-bold text-left">Workspaces</h2>
                <p className="text-sm text-gray-600 text-left">This wallet is linked to the following Workspaces</p>
              </div> <br></br>
            </CardHeader>

            <CardContent>
              <div className='rounded-md border' >
                <Table className="rounded-xl whitespace-nowrap border-gray-200" style={{ color: "#020202", fontSize: "14px" }}>
                  <TableHeader className="text-center">
                    <TableRow>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start ml-2">
                          Workspace
                        </div>
                      </TableHead>
                      <TableHead>
                        <div className="flex items-center gap-2 justify-end">
                          Paired at
                        </div>
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody className="text-left">
                    {workspaceslist.map((workspaceItem, index) => (
                      <TableRow key={index}>
                        <TableCell className="flex items-center space-x-3 py-4 ml-2">
                          <Avatar>
                            <AvatarImage
                              src={`data:image/png;base64,${workspaceItem.workspace_image}`}
                              alt={workspaceItem.workspace_name}
                            />
                            <AvatarFallback>{workspaceItem.workspace_name[0]}</AvatarFallback>
                          </Avatar>
                          <span>{workspaceItem.workspace_name}</span>
                          {workspaceItem.workspace_info_id === workspaceId && (
                            <Badge className="ml-2 bg-blue-500 text-white">You</Badge>
                          )}
                          <Badge className="ml-2 bg-[#DFA548] text-white">
                            {workspaceItem.is_wallet_status ? "Paired" : "Unpaired"}
                          </Badge>
                        </TableCell>

                        <TableCell className="text-right">
                          <div className="flex items-center gap-2 justify-end">
                            {convertUTCToLocal(workspaceItem.created_date, workspaceTimezone).localDate}
                          </div>
                        </TableCell>

                        <TableCell className="text-center">
                          <DropdownMenu>
                            <DropdownMenuTrigger className="ml-2 cursor-pointer">•••</DropdownMenuTrigger>
                            <DropdownMenuContent className="absolute right-0 mt-0" style={{ width: "60px" }}>
                              {workspaceItem.is_wallet_status ? (
                                <DropdownMenuItem
                                  className="mt-0 cursor-pointer"
                                  style={{ color: "red" }}
                                  onClick={() => updateWalletStatus(false, workspaceItem.workspace_info_id, accountId)}
                                // Unpair sets status to false
                                >
                                  Unpair
                                </DropdownMenuItem>
                              ) : (
                                <DropdownMenuItem
                                  className="mt-0 cursor-pointer"
                                  onClick={() => updateWalletStatus(true, workspaceItem.workspace_info_id, accountId)}  // Pair sets status to true
                                >
                                  Pair
                                </DropdownMenuItem>
                              )}

                            </DropdownMenuContent>
                          </DropdownMenu>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>


                </Table>
              </div>
            </CardContent>

          </Card>
          {/* { Transactions }  */}
          <Card className='mb-28 mt-6'>
            <CardHeader>
              <div>
                <h2 className="text-lg font-bold text-left">Transactions</h2>
                <p className="text-sm text-gray-600 text-left">Here you can view your transactions.</p>
              </div> <br></br>
              {/* <Input placeholder="Search transactions..." /> */}
            </CardHeader>

            <CardContent className="mt-[0px]">
              <div className='rounded-md border' >
                <Table className="rounded-xl whitespace-nowrap border-gray-200" style={{ color: "#020202", fontSize: "14px" }}>
                  <TableHeader className="text-center">
                    <TableRow>
                      <TableHead className="text-left">
                        <div className="flex items-center gap-2 justify-start ml-2">
                          Value
                        </div>
                      </TableHead>
                      <TableHead>
                        <div className="flex items-center gap-2 justify-start">
                          Messages
                        </div>
                      </TableHead>
                      <TableHead>
                        <div className="flex items-center gap-2 justify-start">
                          Plan
                        </div>
                      </TableHead>
                      <TableHead>
                        <div className="flex items-center gap-2 justify-start">
                          Description
                        </div>
                      </TableHead>
                      <TableHead>
                        <div className="flex items-center gap-2 justify-start">
                          Date
                        </div>
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  {Array.isArray(transactionList) && transactionList.length > 0 ? (
                    transactionList.map((transactionItem, index) => (
                      <TableRow key={index}>
                        <TableCell className="flex items-center space-x-2 py-4 ml-2">
                          {/* <span>{transactionItem.currency?.toUpperCase()}</span> <span>{transactionItem.amount}</span> */}
                          <span>{transactionItem.currency?.toUpperCase()}</span>
                          <span>{transactionItem.amount > 0 ? transactionItem.amount : ''}</span>
                          {/* 

                          <Badge
                            className="text-white"
                            style={{
                              backgroundColor: "#3399ff",
                            }}
                          >
                            Credit
                          </Badge> */}
                          {transactionItem.amount !== 0 ? (
                            <Badge
                              className="text-white"
                              style={{ backgroundColor: "#3399ff" }}
                            >
                              Credit
                            </Badge>
                          ) : (
                            <span>-</span>
                          )}

                        </TableCell>
                        <TableCell className="text-right">
                          <div className="flex items-center gap-2 justify-start">{transactionItem.credited_msg_count}</div>
                        </TableCell>
                        <TableCell className="text-right">
                          <div className="flex items-center gap-2 justify-start">
                            {/* {transactionItem.plan_name} */}
                            <span>{transactionItem.plan_name !== '' ? transactionItem.plan_name : '-'}</span>

                          </div>
                        </TableCell>
                        <TableCell className="text-right">
                          <div className="flex items-center gap-2 justify-start">
                            {transactionItem.plan_desc}
                          </div>
                        </TableCell>
                        <TableCell className="text-right">
                          {/* <div className="flex items-center gap-2 justify-start">
                            {transactionItem.payment_time
                              ? new Date(transactionItem.payment_time).toLocaleDateString("en-GB")
                              : "-"}
                          </div> */}
                          {/* <div className="flex items-center gap-2 justify-start">
  {transactionItem.payment_time
    ? convertUTCToLocal(transactionItem.payment_time, "America/New_York").localDate
    : "-"}
</div> */}

                          <div className="flex items-center gap-2 justify-start">
                            {transactionItem.payment_time
                              ? convertUTCToLocal(transactionItem.payment_time, workspaceTimezone).localDate
                              : "-"}
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <DropdownMenu>
                            {transactionItem.receipt_url &&
                              <DropdownMenuTrigger className="ml-2 cursor-pointer">•••</DropdownMenuTrigger>
                            }

                            <DropdownMenuContent
                              className="absolute right-0"
                              style={{ width: "145px" }}
                            >
                              <DropdownMenuItem
                                onClick={() => {
                                  if (transactionItem.receipt_url) {
                                    downloadInvoice(transactionItem.receipt_url);
                                  }
                                }}
                                disabled={!transactionItem.receipt_url}
                                className={`cursor-pointer ${!transactionItem.receipt_url ? 'opacity-50 cursor-not-allowed' : ''}`}
                              >
                                Download invoice
                              </DropdownMenuItem>


                            </DropdownMenuContent>
                          </DropdownMenu>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} className="text-center py-4">
                        No credit transactions available.
                      </TableCell>
                    </TableRow>
                  )}


                </Table>
              </div>
            </CardContent>

          </Card>
        </>
      )}
    </div>
  );
};

export default Billing;

